/* eslint-disable default-case */
import { useLocation } from 'react-router-dom';
import { DetailType } from 'app/modules/detail-module/data';

export function getBreadcrumbs(type: DetailType, param: string, data: any) {
  const location = useLocation();

  const first = location.pathname.split('/')[1];

  const labelTypeMap = () => {
    switch (type) {
      case 'country':
        return 'Countries';
      case 'donor':
        return 'Donors';
      case 'organisation':
        return 'Organisations';
      case 'publisher':
        return 'Publishers';
      default:
        return '';
    }
  };

  const labelNameMap = () => {
    switch (type) {
      case 'donor':
      case 'organisation':
      case 'publisher':
        return data.data && data.data.name ? data.data.name : param;
      default:
        return param;
    }
  };

  return [
    {
      label: 'Explore',
      path: '/app',
    },
    {
      label: labelTypeMap(),
      path:
        labelTypeMap() === 'Countries'
          ? undefined
          : `${first}/${param}/projects`,
    },
    {
      label: labelNameMap(),
      path: undefined,
    },
  ];
}
